import { useState, useCallback } from 'react';
import * as subscriptionTemplateService from '../services/subscriptionTemplateService';
import { OPERATION_STATUS, UX_TIMING } from '../constants';

export const useSubscriptionTemplates = () => {
    const [templates, setTemplates] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [operationStatus, setOperationStatus] = useState(null);
    const [operatingTemplateName, setOperatingTemplateName] = useState('');

    const loadTemplates = useCallback(async () => {
        try {
            setLoading(true);
            setError(null);
            const response = await subscriptionTemplateService.getSubscriptionTemplates();
            if (response.success) {
                setTemplates(response.data);
            } else {
                setError(response.message || 'Error al cargar las plantillas.');
            }
        } catch (err) {
            setError(err.message || 'Ocurrió un error inesperado.');
        } finally {
            setLoading(false);
        }
    }, []);

    const executeOperation = useCallback(async (operation, templateDescription) => {
        setOperatingTemplateName(templateDescription);
        setOperationStatus(OPERATION_STATUS.LOADING);
        const startTime = Date.now();

        try {
            const response = await operation();
            
            const elapsedTime = Date.now() - startTime;
            const remainingTime = Math.max(0, UX_TIMING.LOADING_MIN_TIME - elapsedTime);
            
            if (remainingTime > 0) {
                await new Promise(resolve => setTimeout(resolve, remainingTime));
            }

            if (response.success) {
                setOperationStatus(OPERATION_STATUS.SUCCESS);
                await loadTemplates();
                return { success: true };
            } else {
                setOperationStatus(OPERATION_STATUS.ERROR);
                return { success: false, message: response.message };
            }
        } catch (err) {
            setOperationStatus(OPERATION_STATUS.ERROR);
            return { success: false, message: err.message };
        }
    }, [loadTemplates]);

    const updateTemplate = useCallback(async (templateId, templateData) => {
        const templateDescription = `Plantilla para ${templateData.event_type}`;
        return executeOperation(() => subscriptionTemplateService.updateSubscriptionTemplate(templateId, templateData), templateDescription);
    }, [executeOperation]);

    const updateAllTemplates = useCallback(async (templatesData) => {
        const templateDescription = 'plantillas de suscripción';
        return executeOperation(() => subscriptionTemplateService.updateSubscriptionTemplates(templatesData), templateDescription);
    }, [executeOperation]);
    
    const resetOperationState = useCallback(() => {
        setOperationStatus(null);
        setOperatingTemplateName('');
    }, []);


    return {
        templates,
        loading,
        error,
        loadTemplates,
        updateTemplate,
        updateAllTemplates,
        operationStatus,
        operatingTemplateName,
        resetOperationState,
    };
}; 